import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles"; // Import ThemeProvider
import Nav from "./Components/Nav";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Lessons from "./Pages/Lessons";
import Programs from "./Pages/Programs";
import theme from './theme'; // Import your theme

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Nav /> {/* Nav is outside the Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/lessons" element={<Lessons />} />
          <Route path="/programs" element={<Programs />} />
          {/* <Route path="/appointment" element={<Appointment />} /> Appointment route */}
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;